module.exports = __webpack_public_path__ + "img/25.79fe0f04.svg";